import Vue from 'vue'
import * as types from '../mutation-types'
import catalog from '../../api/catalog';

// initial state
const state = {
    loaded: false,
    editItem: null,
    editCategory: null,
    showCreateItem: false,
    showCreateCategory: false,
    categories: null
}

// getters
const getters = {
    loaded: state => state.loaded,
    editItem: state => state.editItem,
    editCategory: state => state.editCategory,
    showCreateItem: state => state.showCreateItem,
    showCreateCategory: state => state.showCreateCategory,
    categories: state => state.categories
}

// actions
const actions = {
    editItem({commit}, item) {
        commit(types.CATALOG_UPDATE_ITEM, item)
    },
    editCategory({commit}, item) {
        commit(types.CATALOG_UPDATE_CATEGORY, item)
    },
    resetItem({commit}) {
        commit(types.CATALOG_UPDATE_ITEM, null)
    },
    resetCategory({commit}) {
        commit(types.CATALOG_UPDATE_CATEGORY, null)
    },
    showCreateItemForm({commit}, data) {
        commit(types.CATALOG_SHOW_CREATE_ITEM_FORM, data)
    },
    showCreateCategoryForm({commit}, data) {
        commit(types.CATALOG_SHOW_CREATE_CATEGORY_FORM, data)
    },
    async createItem({commit, dispatch}, data) {
        try {
            let resp = await catalog.store(data.item)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            commit(types.CATALOG_SHOW_CREATE_ITEM_FORM, false)

            dispatch('notification/updateError', null, {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich erstellt.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async createCategory({commit, dispatch}, data) {
        try {
            let resp = await catalog.storeCategory(data.item)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            commit(types.CATALOG_SHOW_CREATE_CATEGORY_FORM, false)
            dispatch('notification/updateError', null, {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich erstellt.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async updateItem({commit, dispatch}, data) {
        try {
            let resp = await catalog.update(data)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            commit(types.CATALOG_UPDATE_ITEM, null)

            dispatch('notification/updateError', null, {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich geändert.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async updateCategory({commit, dispatch}, data) {
        try {
            let resp = await catalog.updateCategory(data)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            commit(types.CATALOG_UPDATE_CATEGORY, null)

            dispatch('notification/updateError', null , {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich geändert.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async deleteItem({commit, dispatch}, data) {
        try {
            let resp = await catalog.delete(data.id)
            commit(types.CATALOG_GET_ITEMS, resp.data)

            dispatch('notification/updateError', null , {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich gelöscht.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async deleteCategory({commit, dispatch}, data) {
        try {
            let resp = await catalog.deleteCategory(data.id)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null , {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich gelöscht.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    },
    async updateOrder({commit, dispatch}, data) {
        try {
            let resp = await catalog.updateItemsOrder(data.items)
            await commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null , {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    },
    async updateCategoryOrder({commit, dispatch}, data) {
        try {
            let resp = await catalog.updateCategoryOrder(data)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null , {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    },
    async loadItems({commit, dispatch}, locationId) {
        try {
            let resp = await catalog.items(locationId)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null , {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    }
}

// mutations
const mutations = {
    [types.CATALOG_UPDATE_ITEM](state, data) {
        if(data) {
            state.editItem = data
        } else {
            state.editItem = null
        }
    },
    [types.CATALOG_UPDATE_CATEGORY](state, data) {
        if(data) {
            state.editCategory = data
        } else {
            state.editCategory = null
        }
    },
    [types.CATALOG_GET_ITEMS](state, data) {
        Vue.set(state, 'categories', data);
    },
    [types.CATALOG_SHOW_CREATE_ITEM_FORM](state, data) {
        state.showCreateItem = data
    },
    [types.CATALOG_SHOW_CREATE_CATEGORY_FORM](state, data) {
        state.showCreateCategory = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
